import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { setBodyOverflow } from 'src/helpers/utils';
import { CmsRelation, CmsRelationItem } from 'src/types/cms/cmsFieldTypes';
import { CmsStoryGroup } from 'src/types/cms/cmsWidgetTypes';
import './Stories.scss';
import { StoriesModal } from './StoriesModal';

type CmsExtendedRelationItem = CmsRelationItem<CmsStoryGroup> & { isViewed?: boolean };

const StoriesWidget: FC<{ storiesData?: CmsRelation<CmsStoryGroup> | null }> = ({ storiesData }) => {
  const [storiesGroups, setStoriesGroups] = useState<CmsExtendedRelationItem[] | null>(null);
  const [group, setGroup] = useState<CmsExtendedRelationItem | null>(null);

  const checkIfGroupIsViewed = (groupTitle: string): boolean => {
    let viewStoryGroups: any = localStorage.getItem('viewStoryGroups');

    if (viewStoryGroups) {
      viewStoryGroups = JSON.parse(viewStoryGroups);
      return viewStoryGroups.includes(groupTitle);
    }

    return false;
  };

  const handleSetGroup = (group: CmsRelationItem<CmsStoryGroup>): void => {
    setGroup(group);
    setBodyOverflow('unset');
  };

  const handleClose = (): void => {
    setGroup(null);
    setBodyOverflow('set');
  };

  const handleAllStoriesEnd = (groupTitle?: string): void => {
    if (!groupTitle || checkIfGroupIsViewed(groupTitle)) return;

    let viewStoryGroups: any = localStorage.getItem('viewStoryGroups');

    if (viewStoryGroups) {
      viewStoryGroups = JSON.parse(viewStoryGroups);
      viewStoryGroups.push(groupTitle);
      localStorage.setItem('viewStoryGroups', JSON.stringify(viewStoryGroups as string[]));
    } else {
      localStorage.setItem('viewStoryGroups', JSON.stringify([groupTitle] as string[]));
    }

    const updatedGroups =
      storiesGroups
        ?.filter((group) => group.relation !== null)
        ?.map((group) => ({
          ...group,
          isViewed: checkIfGroupIsViewed(group.relation!.title),
        })) || [];

    setStoriesGroups(updatedGroups as any);
  };

  useEffect(() => {
    const setCheckedData =
      storiesData
        ?.filter((group) => group.relation !== null)
        ?.map((group) => ({
          ...group,
          isViewed: checkIfGroupIsViewed(group.relation!.title),
        })) || [];

    setStoriesGroups(setCheckedData as any);
  }, [storiesData]);

  return storiesData && storiesData.length ? (
    <div className="Stories">
      <div className="StoriesList react-horizontal-scrolling-menu--scroll-container">
        {storiesGroups?.map((group) => {
          return (
            <button onClick={() => handleSetGroup(group)} key={group.relation?.title} className="StoriesItemWrapper">
              <div
                className={classNames('StoriesItem', {
                  StoriesItemViewed: group?.isViewed,
                })}
              >
                <img
                  className="StoriesItemImage"
                  src={group.relation?.groupImage?.path}
                  alt={group.relation?.groupImage?.original_name}
                />
                {group.relation?.label && <div className="StoriesItemLabel">{group.relation?.label}</div>}
              </div>
              <span className="StoriesItemName">{group.relation?.title}</span>
            </button>
          );
        })}
      </div>

      <StoriesModal
        groupTitle={group?.relation?.title}
        open={!!group}
        onClose={handleClose}
        onAllStoriesEnd={handleAllStoriesEnd}
        stories={group?.relation?.stories || []}
      />
    </div>
  ) : null;
};

export default StoriesWidget;
